import { connect } from 'react-redux';

import { openMenu, closeMenu } from 'actions/menu';
import Navigation from './Navigation';

function mapStateToProps(state, ownProps) {
  const { menu } = state;
  return {
    isMenuOpen: menu.isOpen,
  };
}

const mapDispatchToProps = {
  openMenu,
  closeMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Header/NavigationContainer.js